/**
 * @generated SignedSource<<2b76a9699bb90fefe77795c48f3ecf3f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddAbtestScenarioPageContentScenarioInput = {
  clientMutationId?: string | null;
  abtestScenarioPageId: string;
  image?: File | Blog | null;
  beforeSrc: string;
};
export type ABTestPatternEditScreenContainer_AddImageContentMutation$variables = {
  input: AddAbtestScenarioPageContentScenarioInput;
};
export type ABTestPatternEditScreenContainer_AddImageContentMutationVariables = ABTestPatternEditScreenContainer_AddImageContentMutation$variables;
export type ABTestPatternEditScreenContainer_AddImageContentMutation$data = {
  readonly addAbtestScenarioPageContentScenario: {
    readonly abtestScenarioPageContentEdge: {
      readonly node: {
        readonly __typename: "AbtestScenarioPageContentScenario";
        readonly id: string;
        readonly image: string | null;
        readonly imageUrl: string | null;
        readonly beforeSrc: string | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null;
    } | null;
  } | null;
};
export type ABTestPatternEditScreenContainer_AddImageContentMutationResponse = ABTestPatternEditScreenContainer_AddImageContentMutation$data;
export type ABTestPatternEditScreenContainer_AddImageContentMutation = {
  variables: ABTestPatternEditScreenContainer_AddImageContentMutationVariables;
  response: ABTestPatternEditScreenContainer_AddImageContentMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "beforeSrc",
      "storageKey": null
    }
  ],
  "type": "AbtestScenarioPageContentScenario",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ABTestPatternEditScreenContainer_AddImageContentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddAbtestScenarioPageContentScenarioPayload",
        "kind": "LinkedField",
        "name": "addAbtestScenarioPageContentScenario",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AbtestScenarioPageContentEdge",
            "kind": "LinkedField",
            "name": "abtestScenarioPageContentEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ABTestPatternEditScreenContainer_AddImageContentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddAbtestScenarioPageContentScenarioPayload",
        "kind": "LinkedField",
        "name": "addAbtestScenarioPageContentScenario",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AbtestScenarioPageContentEdge",
            "kind": "LinkedField",
            "name": "abtestScenarioPageContentEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5407a4a82e8f574be18a34a5c7c168ad",
    "id": null,
    "metadata": {},
    "name": "ABTestPatternEditScreenContainer_AddImageContentMutation",
    "operationKind": "mutation",
    "text": "mutation ABTestPatternEditScreenContainer_AddImageContentMutation(\n  $input: AddAbtestScenarioPageContentScenarioInput!\n) {\n  addAbtestScenarioPageContentScenario(input: $input) {\n    abtestScenarioPageContentEdge {\n      node {\n        __typename\n        ... on AbtestScenarioPageContentScenario {\n          id\n          image\n          imageUrl\n          beforeSrc\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "66b3b587498ae4458141e1ec2a572965";

export default node;
